import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { ProcessItemServiceManager } from "../ProcessItemServices/ProcessItemServiceManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceItemOpenPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceItemOpenProperties = {
    [name in keyof EntityCommandProcessInstanceItemOpenPropertyValues]: Property<EntityCommandProcessInstanceItemOpenPropertyValues[name]>
};

export interface IEntityCommandProcessInstanceItemOpen extends IEntityCommand, EntityCommandProcessInstanceItemOpenProperties
{
}

export class EntityCommandProcessInstanceItemOpen extends EntityCommand implements IEntityCommandProcessInstanceItemOpen
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceItemOpen";
    public static override className = "EntityCommandProcessInstanceItemOpen";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceItemOpenPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Open",
                entityName: "ProcessInstanceItem",
                isDefault: true,
                key: "OPEN",
                permission: PermissionEvaluator.permissionLevels.update,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceItemOpenPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            recordId = entityCommandInformation.getRecordId();

        if (!recordId)
            return;

        const
            data = await ProcessItemServiceManager.claimProcessInstanceItemAsync(recordId);

        if (!data)
            return;

        const
            processItemService = await ProcessItemServiceManager.getRequiredAsync(data.processItemServiceId);

        processItemService.processInstanceItemId.set(recordId);
        processItemService.processItemServiceProperties.set(ObjectHelper.fromJson(data.processItemServiceProperties));

        await processItemService.executeAsync();
    }

    // #endregion

    // #endregion
}

